module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "form-sections"
  }, _vm._l((_vm.brands), function(brand, index) {
    return _c('div', {
      key: index,
      staticClass: "brand-container"
    }, [_c('div', {
      staticClass: "brand-title-container"
    }, [_c('h4', [_c('b', [_vm._v(_vm._s(brand) + "-" + _vm._s(_vm.lang.W00050))])]), _vm._v(" "), _c('div', {
      staticClass: "apply-visits-container"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.visitsToApply.scenarioId),
        expression: "visitsToApply.scenarioId"
      }],
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.visitsToApply, "scenarioId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "hidden": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.lang.W00080))]), _vm._v(" "), _vm._l((_vm.localFormData.scenarios), function(scenario) {
      return _c('option', {
        key: scenario.ScenarioId,
        domProps: {
          "value": scenario.ScenarioId
        }
      }, [_vm._v(_vm._s(scenario.ScenarioName))])
    })], 2), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.visitsToApply.number),
        expression: "visitsToApply.number"
      }],
      attrs: {
        "type": "number",
        "min": 0,
        "step": 1,
        "disabled": _vm.readonly
      },
      domProps: {
        "value": (_vm.visitsToApply.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.visitsToApply, "number", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "wizard-btn-dark",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "click": function($event) {
          return _vm.applyVisits(brand)
        }
      }
    }, [_vm._v(_vm._s(_vm.lang.W00079))])])]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-container"
    }, [_c('div', {
      staticClass: "wizard-table-header"
    }, [_c('div', {
      staticClass: "wizard-table-settings-container"
    }, [_c('i', {
      staticClass: "material-icons cursor-pointer",
      on: {
        "click": function($event) {
          _vm.showTableSettings = !_vm.showTableSettings
        }
      }
    }, [_vm._v("more_vert")]), _vm._v(" "), (_vm.showTableSettings) ? _c('div', {
      staticClass: "wizard-table-settings-list"
    }, _vm._l((Object.entries(_vm.columns)), function(ref, index) {
      var key = ref[0];
      var value = ref[1];

      return _c('div', {
        staticClass: "wizard-table-settings-list-element"
      }, [_c('span', {
        staticStyle: {
          "width": "max-content"
        }
      }, [_vm._v(_vm._s(value.lang ? _vm.lang[value.lang] : key))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (value.visible),
          expression: "value.visible"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": value.disabled
        },
        domProps: {
          "checked": Array.isArray(value.visible) ? _vm._i(value.visible, null) > -1 : (value.visible)
        },
        on: {
          "change": [function($event) {
            var $$a = value.visible,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(value, "visible", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(value, "visible", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(value, "visible", $$c)
            }
          }, function($event) {
            _vm.applyColumnGrid(), _vm.resetFilter(key, value.visible, brand)
          }]
        }
      })])
    }), 0) : _vm._e()]), _vm._v(" "), (_vm.columns.LocationStoreId.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00035) + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].LocationStoreId && _vm.filter[brand].LocationStoreId.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'LocationStoreId')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].LocationStoreId && _vm.filter[brand].LocationStoreId.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].LocationStoreId.text),
        expression: "filter[brand].LocationStoreId.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].LocationStoreId.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].LocationStoreId, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].LocationStoreId.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.LocationName.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00051) + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].LocationName && _vm.filter[brand].LocationName.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'LocationName')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].LocationName && _vm.filter[brand].LocationName.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].LocationName.text),
        expression: "filter[brand].LocationName.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].LocationName.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].LocationName, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].LocationName.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.displayAddress.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00052) + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].displayAddress && _vm.filter[brand].displayAddress.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'displayAddress')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].displayAddress && _vm.filter[brand].displayAddress.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].displayAddress.text),
        expression: "filter[brand].displayAddress.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].displayAddress.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].displayAddress, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].displayAddress.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Brand.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Brand") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Brand && _vm.filter[brand].Brand.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Brand')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Brand && _vm.filter[brand].Brand.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Brand.text),
        expression: "filter[brand].Brand.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Brand.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Brand, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Brand.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Countries.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Countries") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Countries && _vm.filter[brand].Countries.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Countries')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Countries && _vm.filter[brand].Countries.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Countries.text),
        expression: "filter[brand].Countries.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Countries.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Countries, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Countries.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Checkanlage") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Checkanlage && _vm.filter[brand].Checkanlage.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Checkanlage')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Checkanlage && _vm.filter[brand].Checkanlage.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Checkanlage.text),
        expression: "filter[brand].Checkanlage.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Checkanlage.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Checkanlage, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Checkanlage.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage2.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Checkanlage2") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Checkanlage2 && _vm.filter[brand].Checkanlage2.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Checkanlage2')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Checkanlage2 && _vm.filter[brand].Checkanlage2.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Checkanlage2.text),
        expression: "filter[brand].Checkanlage2.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Checkanlage2.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Checkanlage2, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Checkanlage2.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage3.visible) ? _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s("Checkanlage3") + "\n              "), _vm._v(" "), _c('svg', {
      staticClass: "wizard-table-filter-icon",
      class: {
        'filled': (_vm.filter[brand] && _vm.filter[brand].Checkanlage3 && _vm.filter[brand].Checkanlage3.text)
      },
      attrs: {
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-linejoin": "round",
        "stroke-linecap": "round"
      },
      on: {
        "click": function($event) {
          return _vm.showFilter(brand, 'Checkanlage3')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 6h16l-6 7v5l-4-2v-3l-6-7z"
      }
    })]), _vm._v(" "), (_vm.filter[brand] && _vm.filter[brand].Checkanlage3 && _vm.filter[brand].Checkanlage3.show) ? _c('div', {
      staticClass: "wizard-table-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[brand].Checkanlage3.text),
        expression: "filter[brand].Checkanlage3.text"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Search"
      },
      domProps: {
        "value": (_vm.filter[brand].Checkanlage3.text)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filter[brand].Checkanlage3, "text", $event.target.value)
        }, function($event) {
          _vm.applyColumnGrid();
          _vm.$forceUpdate()
        }],
        "blur": function($event) {
          _vm.filter[brand].Checkanlage3.show = false;
          _vm.applyColumnGrid();
          _vm.$forceUpdate();
        }
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-header-cell"
    }, [_vm._v("\n              " + _vm._s(_vm.lang.W00053) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-body"
    }, _vm._l((_vm.getLocationsOfBrand(brand)), function(location) {
      return _c('div', {
        key: location.id,
        staticClass: "wizard-table-row"
      }, [(_vm.columns.LocationStoreId.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.LocationStoreId))]) : _vm._e(), _vm._v(" "), (_vm.columns.LocationName.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.LocationName))]) : _vm._e(), _vm._v(" "), (_vm.columns.displayAddress.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.displayAddress))]) : _vm._e(), _vm._v(" "), (_vm.columns.Brand.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Brand))]) : _vm._e(), _vm._v(" "), (_vm.columns.Countries.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Countries))]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Checkanlage))]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage2.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Checkanlage2))]) : _vm._e(), _vm._v(" "), (_vm.columns.Checkanlage3.visible) ? _c('div', {
        staticClass: "wizard-table-cell"
      }, [_vm._v(_vm._s(location.Checkanlage3))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "wizard-table-cell"
      }, _vm._l((_vm.localFormData.scenarios), function(scenario) {
        return _c('div', {
          staticClass: "scenario-input"
        }, [_c('span', [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('input', {
          staticClass: "wizard-input",
          attrs: {
            "type": "number",
            "min": 0,
            "step": 1,
            "disabled": _vm.readonly
          },
          domProps: {
            "value": _vm.getNumberOfVisits(location.LocationId, scenario.ScenarioId)
          },
          on: {
            "change": function($event) {
              return _vm.setNumberOfVisits(location.LocationId, scenario.ScenarioId, $event)
            }
          }
        })])
      }), 0)])
    }), 0)]), _vm._v(" "), _vm._l((_vm.brandVisits), function(bv) {
      return (bv.brand == brand) ? _c('div', {
        staticClass: "brand-computed-data"
      }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.lang.W00072) + " " + _vm._s(bv.checkCount))])]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.lang.W00073) + " " + _vm._s(bv.locationsWithChecksCount))])]), _vm._v(" "), _vm._l((bv.scenarios), function(scenario) {
        return _c('span', [_c('b', [_vm._v(_vm._s(scenario.scenarioName) + ": " + _vm._s(scenario.checkCount))])])
      })], 2) : _vm._e()
    })], 2)
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff33a946","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/Step6.vue
// module id = 1739
// module chunks = 1